import { mulberry32 } from "../utils/prng.mjs";
import { ELEMENT_NAMES } from "../assets/elements.js";
// Helper function to turn a string UUID into a highly distributed 32-bit integer seed
function hashUUIDToSeed(str) {
    let hash = 1779033703 ^ str.length;
    for (let i = 0; i < str.length; i++) {
        hash = Math.imul(hash ^ str.charCodeAt(i), 3432918353);
        hash = hash << 13 | hash >>> 19;
    }
    hash = Math.imul(hash ^ hash >>> 16, 2246822507);
    hash = Math.imul(hash ^ hash >>> 13, 3266489909);
    return (hash ^ hash >>> 16) >>> 0;
}

//export const ELEMENT_NAMES = ["fire", "earth", "light", "wind", "cold", "water", "lightning", "dark"]
const shardConstants = {
    //Modifiers and percentages for each element:
    fire: {

    },
    earth: {

    },
    light: {

    },
    wind: {

    }, 
    cold: {

    },
    water: {

    },
    lightning: {

    },
    dark: {

    }
}

const SHARD_TIERS = {
    tier1: {
        speedRange: [0.5, 1],
        powerRange: [10, 100]
    },
    tier2: {
        speedRange: [0.5, 1],
        powerRange: [100, 350]
    },
    tier3: {
        speedRange: [0.5, 1],
        powerRange: [350, 1000]
    }
};

export class Shard {
    constructor(uuid, element, tier) {
        this.spellUUID = uuid;
        this.element = element;
        this.tier = tier || 1;
        this.tierName = `tier${this.tier}`;
        this.rollNum = 0; //to add later
        
        this.stats = {
            basePower: 0,
            castSpeed: 0,
            mpCost: 0
        };

        this.generateStats();
    }

    generateStats() {
        const config = SHARD_TIERS[this.tierName] || SHARD_TIERS.tier1;
        
        // 2. Hash UUID string down to a safe integer seed and boot the PRNG
        const numericSeed = hashUUIDToSeed(this.spellUUID);
        const rand = mulberry32(numericSeed);


        const [minPower, maxPower] = config.powerRange;
        this.stats.basePower = Math.floor(minPower + rand() * (maxPower - minPower + 1));

        // 5. Roll Speed (using floating point range mapping)
        const [minSpeed, maxSpeed] = config.speedRange;
        const rawSpeed = minSpeed + rand() * (maxSpeed - minSpeed);
        this.stats.castSpeed = Number(rawSpeed.toFixed(2));

        // 6. Calculate MP Cost (Power divided by Speed)
        // We use Math.ceil to make sure MP cost is at least 1
        this.stats.mpCost = Math.ceil(this.stats.basePower / this.stats.castSpeed);

        // TODO: ADD MODIFIER GENERATION (e.g., using additional rand() rolls here)
    }

    // Strips out redundant runtime stats for hyper-efficient saving
    toJSON() {
        return [
            this.spellUUID,
            this.element,
            this.tier
        ];
    }
}